import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]品牌专区列表
 */
export function getBrandUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultBrandAreaParam> {
  return resource.postNoAuth('/brandArea/brand', req, config);
}
